
import { useTranslation } from 'react-i18next';
import { SOCIAL_LINKS } from '../../lib/constants';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-gradient-to-br from-blue-900 via-blue-800 to-blue-700 text-white py-12 relative overflow-hidden">
      {/* Background decoration */}
      <div
        className={`
          absolute inset-0 
          bg-[url('data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.03"%3E%3Ccircle cx="30" cy="30" r="2"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')]
          opacity-50
        `}
      ></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        {/* Main Footer Content */}
        <div className="text-center mb-10">
          {/* Logo */}
          <div className="flex justify-center mb-6">
            <img
              src="https://static.readdy.ai/image/0c50aed3eb71487d515cf1f4733a4b77/dca41deac6d1ef7d0bf8c29028228eab.png"
              alt="Balam Technology Logo"
              className="h-12 w-auto drop-shadow-lg hover:scale-105 transition-transform duration-300"
            />
          </div>

          {/* Description */}
          <p className="text-blue-100 mb-8 max-w-2xl mx-auto text-base font-inter leading-relaxed">
            {t('footer.description')}
          </p>

          {/* Social Links */}
          <div className="flex justify-center space-x-4 mb-10">
            {SOCIAL_LINKS.map((social) => (
              <a
                key={social.name}
                href={social.href}
                className="w-12 h-12 bg-white/10 backdrop-blur-sm text-white rounded-full flex items-center justify-center hover:bg-white hover:text-blue-700 transition-all duration-300 cursor-pointer shadow-lg hover:shadow-xl hover:scale-110 border border-white/20 group"
                aria-label={social.name}
              >
                <i className={`${social.icon} text-lg group-hover:scale-110 transition-transform duration-300`}></i>
              </a>
            ))}
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-blue-600/30 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-3 md:space-y-0">
            <p className="text-blue-200 text-sm font-inter order-2 md:order-1">
              {t('footer.copyright')}
            </p>
            <div className="flex items-center space-x-4 order-1 md:order-2">
              <a
                href="https://readdy.ai/?origin=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-200 hover:text-white text-sm transition-all duration-300 cursor-pointer font-inter hover:scale-105 transform bg-white/10 px-3 py-1.5 rounded-full backdrop-blur-sm border border-white/20 hover:border-white/40 hover:bg-white/20"
              >
                <i className="ri-heart-fill mr-2 text-red-400"></i>
                {t('footer.madeWith')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
